import request from '@/utils/axios';

export const getUserExtensionInfo    = p     => request.get(`/community/open/user/zone/${p}`);
export const greatUser              = p     => request.post(`/community/open/user/zone/${p}/great`);
export const toggleFollow            = p     => request.post(`/community/user/zone/${p}/follow`);
export const getIdols               = ()    => request.get('/community/user/zone/idols');
